import { SNIPPETS_OPTIONS } from '../constants/snippets';

export const filterSnippets = (search: string) =>
	search
		? SNIPPETS_OPTIONS.filter((c) =>
				c.toLowerCase().startsWith(`${search.toLowerCase()}`),
		  )
		: SNIPPETS_OPTIONS;
